/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import {
  AccountV2Query,
  CloudProviderType,
  Provider,
} from "~/generated/graphql";
import { PROVIDERS } from "~/views/accounts/AddAccount/constants";
import { AccountContacts, AccountParams } from "~/views/accounts/types";
import { ACCOUNT_TYPE_LIST } from "./constants";

export function getAccountUrl(id: string, provider: Provider | string) {
  if (provider === Provider.Aws) {
    return `https://${id}.signin.aws.amazon.com/console/`;
  }
  if (provider === Provider.Ibmcloud) {
    return `https://cloud.ibm.com`;
  }
  if (provider === Provider.Azure) {
    return `https://portal.azure.com/#resource/subscriptions/${id}`;
  }
  if (provider === Provider.Gcp) {
    return `https://console.cloud.google.com/home/dashboard?organizationId=${id}`;
  }

  return null;
}

export const isAccountDiscovered = (
  providerType: CloudProviderType | "",
  status: string
) => {
  const providerTypes: (CloudProviderType | "")[] = [
    CloudProviderType.Kubernetes,
    CloudProviderType.Openshift,
    CloudProviderType.Vmware,
  ];
  return providerTypes.includes(providerType) && status === "discovered";
};

export const getInitialAccountParams = (
  filledParams: boolean,
  accountQuery?: AccountV2Query
): AccountParams => {
  return filledParams
    ? {
        provider: accountQuery?.accountV2?.provider ? PROVIDERS.hybrid : "",
        providerType: accountQuery?.accountV2?.providerType || "",
        name: accountQuery?.accountV2?.name,
        status: accountQuery?.accountV2?.status?.toString(),
      }
    : {
        provider: "",
      };
};

export const getInitialSettings = (
  filledSettings: boolean,
  accountQuery?: AccountV2Query
): AccountContacts => {
  return Object.assign(
    { contactIds: "" },
    { ownerId: filledSettings ? accountQuery?.accountV2?.owner?.id ?? "" : "" }
  );
};

export const getAccountOptions = (
  provider: Provider | "",
  providerType: CloudProviderType | ""
) => {
  return ACCOUNT_TYPE_LIST.find((tab) => {
    if (provider !== Provider.Hybrid && provider !== "") {
      return tab.filter.providers?.includes(provider);
    }
    if (provider === Provider.Hybrid && providerType !== "") {
      return tab.filter.providerTypes?.includes(providerType);
    }
    return false;
  });
};
